import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api, errMsg } from '../../lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { Ticket } from '@phosphor-icons/react';

export const AlertActions = ({ alert, connectors, tickets, onCreated }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const existing = (tickets || []).find((t) => t.linked_entity === alert.key && !['resolved', 'closed'].includes(t.status));
  const create = async (connector_id, priority, subject, description) => {
    setBusy(true);
    try {
      const r = await api.post('/itsm/tickets', { connector_id, priority, subject, description, linked_entity: alert.key });
      toast.success(`Ticket ${r.data.external_id || ''} created from alert`);
      setOpen(false);
      onCreated?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (existing) {
    return <Link to="/itsm" data-testid={`alert-ticket-link-${alert.key}`}
      className="shrink-0 font-mono-label text-[9px] uppercase bg-slate-100 text-slate-600 rounded px-1.5 py-0.5 hover:text-orange-700">Ticket {existing.external_id || 'pending'}</Link>;
  }
  if (!connectors?.length) return null;
  const defaults = {
    connector_id: connectors[0].id, priority: 'high', subject: alert.message.slice(0, 120),
    description: `${alert.message}\n\nSeverity: ${alert.severity}\nRaised from the ONRID IT Operations alert feed.`,
  };
  return (
    <span className="shrink-0 flex gap-1">
      <button data-testid={`alert-quick-ticket-${alert.key}`} disabled={busy}
        onClick={() => create(defaults.connector_id, defaults.priority, defaults.subject, defaults.description)}
        className="text-xs border border-slate-200 rounded px-2 py-1 hover:border-orange-500 flex items-center gap-1"><Ticket size={12} />Ticket</button>
      <button data-testid={`alert-ticket-dialog-${alert.key}`} title="Create with options"
        onClick={() => { setForm(defaults); setOpen(true); }}
        className="text-xs border border-slate-200 rounded px-1.5 py-1 hover:border-orange-500">...</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="alert-ticket-form">
          <DialogHeader><DialogTitle className="font-display">Create ITSM ticket from alert</DialogTitle></DialogHeader>
          {form && (
            <div className="space-y-3">
              <select data-testid="alert-ticket-connector" value={form.connector_id} onChange={(e) => setForm({ ...form, connector_id: e.target.value })}
                className="w-full border border-slate-200 rounded-md px-2 py-2 text-sm bg-white">
                {connectors.map((c) => <option key={c.id} value={c.id}>{`${c.name} (${c.mode})`}</option>)}
              </select>
              <select data-testid="alert-ticket-priority" value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })}
                className="w-full border border-slate-200 rounded-md px-2 py-2 text-sm bg-white">
                {['low', 'medium', 'high', 'urgent'].map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
              <Input data-testid="alert-ticket-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
              <textarea data-testid="alert-ticket-description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })}
                className="w-full border border-slate-200 rounded-md px-3 py-2 text-sm h-24" />
              <Button data-testid="alert-ticket-submit" className="w-full bg-slate-900 hover:bg-slate-800" disabled={busy || !form.subject}
                onClick={() => create(form.connector_id, form.priority, form.subject, form.description)}>Create ticket</Button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </span>
  );
};
